import React, { useState } from "react";
import Slider from "react-slick";
import ProductSlide from "./ProductSlide";
import ReUse from "../services/helpers/reUse";
import Productslidemain from "./ReUse/Productslidemain";

function Slide({ images, thumbnail }) {
	const [nav1, setNav1] = useState();
	const [nav2, setNav2] = useState();
	return (
		<div>
			<Slider asNavFor={nav2} ref={(slider1) => setNav1(slider1)}>
				{ReUse.mapArray(false, images, Productslidemain, "slide")}
			</Slider>

			<Slider
				asNavFor={nav1}
				ref={(slider2) => setNav2(slider2)}
				slidesToShow={3}
				swipeToSlide={true}
				focusOnSelect={true}
				arrows={false}
			>
				{ReUse.mapArray(false, images, ProductSlide, "slide")}
			</Slider>
		</div>
	);
}

export default Slide;
